import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { getRequestRelatedRequestsRecipients } from '../../../../../api'
import { EMPTY_LIST } from '../../../../../constants/common'
import { useScreen } from '../../../../../hooks'
import { getTranslatedOptions } from '../../../../../utils/translation'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_BCC,
  EMAIL_CREATION_FORM_FIELD_NAME_CC,
  EMAIL_CREATION_FORM_FIELD_NAME_MASS_MAILING,
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
  toEmailRecipientSelectItems,
} from '../../../../Email'
import { Field } from '../../../../Field'
import { InputSelect } from '../../../../Select'
import { ATTACHED_REQUESTS_RECIPIENT_TYPE_OWNERS } from '../../RequestProfileTabEmailsAttachedRequestsRecipientsFilterModal'
import {
  CREATE_EMAIL_POPUP_MODE_FIELD_NAME,
  CREATE_EMAIL_POPUP_MODE_OPTIONS,
  QA_NAME_REQUEST_PROFILE_TAB_EMAILS_CREATE_EMAIL_MODE_FIELD,
} from '../RequestProfileTabEmailsCreateEmailPopUp.constants'
import {
  isRequestProfileCreateEmailModeAttachedRequests,
  toAttachedRequestRecipientSelectItem,
} from '../RequestProfileTabEmailsCreateEmailPopUp.utils'

import * as styles from './RequestProfileTabEmailsCreateEmailModeField.module.css'

function RequestProfileTabEmailsCreateEmailModeField({
  mode,
  requestId,
  onModeChange,
}) {
  const { t } = useTranslation()

  const { setFieldValue } = useFormikContext()

  const { isMobileScreenSize } = useScreen()

  const options = getTranslatedOptions({
    options: CREATE_EMAIL_POPUP_MODE_OPTIONS,
    t,
  })

  const selectedOption =
    options.find(option => option.value === mode) ?? options[0]

  function handleSelect({ value: nextMode }) {
    setFieldValue(CREATE_EMAIL_POPUP_MODE_FIELD_NAME, nextMode)
    setFieldValue(EMAIL_CREATION_FORM_FIELD_NAME_CC, EMPTY_LIST)
    setFieldValue(EMAIL_CREATION_FORM_FIELD_NAME_BCC, EMPTY_LIST)
    onModeChange(nextMode)

    if (!isRequestProfileCreateEmailModeAttachedRequests(nextMode)) {
      setFieldValue(EMAIL_CREATION_FORM_FIELD_NAME_TO, EMPTY_LIST)
      setFieldValue(EMAIL_CREATION_FORM_FIELD_NAME_MASS_MAILING, false)

      return
    }

    setFieldValue(EMAIL_CREATION_FORM_FIELD_NAME_MASS_MAILING, true)

    getRequestRelatedRequestsRecipients(requestId, {
      exclude_archived_requests: false,
      recipient_type: ATTACHED_REQUESTS_RECIPIENT_TYPE_OWNERS,
    })
      .then(({ data }) => {
        setFieldValue(
          EMAIL_CREATION_FORM_FIELD_NAME_TO,
          toEmailRecipientSelectItems(
            data.items,
            toAttachedRequestRecipientSelectItem
          )
        )
      })
      .catch(() => {
        setFieldValue(EMAIL_CREATION_FORM_FIELD_NAME_TO, EMPTY_LIST)
      })
  }

  return (
    <Field
      shouldAdaptToMobileScreen
      fieldInputClassName={styles.modeFieldInput}
      label={`${t('RequestProfile.EmailModeLabelKey')}:`}
      labelClassName={styles.modeFieldLabel}
    >
      <InputSelect
        controlProps={{
          borderless: !isMobileScreenSize,
          indicatorsProps: { ButtonClear: null },
        }}
        options={options}
        qaName={QA_NAME_REQUEST_PROFILE_TAB_EMAILS_CREATE_EMAIL_MODE_FIELD}
        value={selectedOption}
        onSelectItem={handleSelect}
      />
    </Field>
  )
}

export default RequestProfileTabEmailsCreateEmailModeField
